<template>
  <div
    class="fe-flex fe-border fe-border-primary-grey-40 fe-border-solid fe-rounded-pill fe-max-w-fit"
  >
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "ButtonGroup",
  }
</script>
